import { useState } from "react";
import ProjectItem from "./ProjectItem";
import projectData from "./../data/project-data.json";
import { BsArrowRight } from "react-icons/bs";

const Projects = () => {
  const [filteredData, setfilteredData] = useState(projectData);
  const [selectedTagIdx, setSelectedTagIdx] = useState(0);

  let allUniqueTags = new Set();

  projectData.forEach((el) => {
    el.tags.forEach((tag) => {
      allUniqueTags.add(tag);
    });
  });

  allUniqueTags = ["all", ...allUniqueTags];

  const onFilterHandler = (tag, idx) => {
    if (tag === "all") {
      setfilteredData(projectData);
    } else {
      const filteredData = projectData.filter((data) =>
        data.tags.includes(tag)
      );
      setfilteredData(filteredData);
    }

    setSelectedTagIdx(idx);
  };

  return (
    <section className="section project">
      <div className="page">
        <h1 className="large-text" data-drop-text="Project">
          Project
        </h1>
        <div className="small-text">My latest project work here.</div>

        <ul className="project__filter__list">
          {allUniqueTags.map((tag, idx) => (
            <li
              key={idx}
              className={`project__filter__item small-text ${idx === selectedTagIdx && "project__filter__item--active"
                }`}
              onClick={() => onFilterHandler(tag, idx)}
            >
              {tag}
            </li>
          ))}
        </ul>

        <ul className="project__list">
          {filteredData.map(({ name, desc, tags, thumbnailImage, liveLink, githubLink }, idx) => (
            <ProjectItem
              key={idx}
              name={name}
              desc={desc}
              tags={tags}
              thumbnailImage={thumbnailImage}
              liveLink={liveLink}
              githubLink={githubLink}
            />
          ))}
        </ul>

        <div className="right">
          <a
            className="btn__link project__btn-see-all"
            href="https://github.com/GhulamAzad"
            target="_blank"
            rel="noreferrer"
          >
            See More Work <BsArrowRight />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;
